export default "__VITE_ASSET__Bsw__uHk__"